export default {"src":"/_next/static/media/check-badge.daf4299e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};